import React from "react";
import { getUpdateTrainDetails, mapTrainToState, TrainFormState } from "shared/utils/fieldsHelper/trainFields";

export const useTrainDetail = (
  train: server.dto.Train,
  travellers: server.dto.ContactSmallV2[],
  files: server.dto.File[],
) => {
  const [state, setState] = React.useState<TrainFormState>(mapTrainToState(train, travellers, files, serverReference));

  React.useEffect(() => {
    setState(mapTrainToState(train, travellers, files, serverReference));
  }, [train, travellers, files]);

  const onValueChanged = (key: string, value: any) => {
    if (key === "artist") {
      setState({ ...state, artist: value });
    } else if (key === "travellers") {
      setState({ ...state, travellers: value });
    } else if (key === "status") {
      setState({ ...state, phase: value });
    } else if (key === "bookingReference") {
      setState({ ...state, bookingReference: value });
    } else if (key === "travelAgency") {
      setState({ ...state, travelAgency: value });
    } else if (key === "notes") {
      setState({ ...state, notes: value });
    } else if (key === "trainNumber") {
      setState({ ...state, trainNumber: value });
    } else if (key === "carriage") {
      setState({ ...state, carriage: value });
    } else if (key === "seats") {
      setState({ ...state, seats: value });
    } else if (key === "travelClass") {
      setState({ ...state, travelClass: value });
    } else if (key === "departureLocal") {
      const diff = value.diff(state.departureLocal, "minutes");
      const newArrivalLocal = state.arrivalLocal.clone().add(diff, "minutes");
      setState({
        ...state,
        departureLocal: value,
        arrivalLocal: newArrivalLocal,
      });
    } else if (key === "departureStation") {
      setState({ ...state, departureStation: value });
    } else if (key === "departurePlatform") {
      setState({ ...state, departurePlatform: value });
    } else if (key === "arrivalLocal") {
      setState({ ...state, arrivalLocal: value });
    } else if (key === "arrivalStation") {
      setState({ ...state, arrivalStation: value });
    } else if (key === "arrivalPlatform") {
      setState({ ...state, arrivalPlatform: value });
    }
  }

  const onSuccessfulArtistUpdate = async (newArtist: server.dto.ArtistSmall) => {
    const result = await window.CoreApi.CompanyToContact.ListContactByCompany({
      companyId: newArtist.artistId,
      defaultSelect: true,
      isActive: true,
      page: 1,
      perPage: 1000,
    });

    if (result.data.hasErrors) {
      return;
    }

    const newTravellers = result.data.data.map(c => ({
      contactId: c.contact.contactId,
      culture: c.contact.culture,
      gender: c.contact.gender,
      isValidated: c.contact.isValidated,
      name: c.contact.name,
      position: c.contact.position,
      profileImageUrl: c.contact.profileImageUrl,
    }))

    const updateDetailsResults = await window.CoreApi.Train.UpdateTrain({
      ...getUpdateTrainDetails({
        ...state,
        artist: newArtist,
        travellers: newTravellers,
      }),
    });

    if (updateDetailsResults.data.hasErrors) {
      return;
    }

    setState({
      ...state,
      artist: newArtist,
      travellers: newTravellers,
    });
  }

  const refetchFiles = async () => {
    const response = await window.CoreApi.Train.GetSidePanelData(train.trainId);

    if (response.data.hasErrors) {
      return;
    }

    setState(prev => ({ ...prev, files: response.data.data.files }));
  }

  const onSuccessfulUpdate = async (key: string, newValue: any) => {
    if (key === "artist") {
      await onSuccessfulArtistUpdate(newValue);
    }
  }

  return {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    refetchFiles,
    getUpdateTrainDetails,
  }
};